import { ITutorialPassos, MensagensPadrao } from '../../../Components/AdicionarAjuda';

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-da-escola",

    filtroDeRazaoSocial: "campo-razao-social-filtros-da-escola",
    filtroDeNomeFantasia: "campo-nome-fantasia-filtros-da-escola",
    filtroDeCNPJ: "campo-cnpj-filtros-da-escola",
    filtroDeAtivo: "campo-ativo-filtros-da-escola",

    botaoListar: "botao-listar-escola",
    botaoAdicionar: "botao-adicionar-escola",
}

export const Classes = {
    botaoEditar: "botao-editar-escola",
    botaoDesativar: "botao-desativar-escola",
}

export const ConsultarEscola: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.razaoSocial, target: () => document.getElementById(IDs.filtroDeRazaoSocial)! },
        { ...MensagensPadrao.filtros.nomeFantasia, target: () => document.getElementById(IDs.filtroDeNomeFantasia)! },
        { ...MensagensPadrao.filtros.cnpj, target: () => document.getElementById(IDs.filtroDeCNPJ)! },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarEscola: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const EditarEscola: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector("." + Classes.botaoEditar)! },
    ]
}

export const DesativarEscola: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector("." + Classes.botaoDesativar)! },
    ]
}
